export class OnEventDispatcher {
    private allSignature:string = "{{ALL_EVENTS}}";
    onlisteners:Array<{ev:string, fn:Function}>;
    nextTickEvents:Array<string>;
    public listenersCountChange:Function = ()=>{};
    constructor() {
      this.onlisteners = [];
      this.nextTickEvents = [];
    }
    dispatch(ev:string, data?:any) {
      for(let m in this.onlisteners) {
        if(this.onlisteners[m].ev==ev) {
                  if(data!=null) {
                      try{this.onlisteners[m].fn(ev, data)}catch(e){console.error("On listener error:", e)};
                  } else {
              try{this.onlisteners[m].fn(ev)}catch(e){console.error("On listener error:", e)};
                  }
        }
      }
      return this;
    }
      dispatchAsync(ev:string, data?:any):Promise<OnEventDispatcher> {
          return new Promise(async (resolve, _reject) => {
          for(let m in this.onlisteners) {
            if(this.onlisteners[m].ev==ev) {
                      if(data!=null) {
                          try{await this.onlisteners[m].fn(ev, data)}catch(e){console.error("On listener error:", e)};
                      } else {
                  try{await this.onlisteners[m].fn(ev)}catch(e){console.error("On listener error:", e)};
                      }
            }
          }
          resolve(this);
          });
    }
    onAny(fn:Function) {
      return this.on(this.allSignature, fn);
    }
    offAny(fn:Function) {
      return this.off(this.allSignature, fn);
    }
    on(ev:string, fn:Function|null = null) {
      if(fn==null) {
        this.dispatch(ev);
      } else {
        this.onlisteners.push({ev, fn});
        if(this.listenersCountChange!=null) this.listenersCountChange(this.onlisteners.length);
      }
      return this;
    }
    off(ev:string, fn:Function|null=null) {
      let i = 0;
      let changed:boolean = false;
      while(i<this.onlisteners.length) {
        if(this.onlisteners[i].ev==ev&&(fn==null||this.onlisteners[i].fn==fn)) {
          this.onlisteners.splice(i,1);
          changed = true;
          i--;
        }
        i++;
      }
      if(changed&&this.listenersCountChange!=null) this.listenersCountChange(this.onlisteners.length);
      return this;
    }
      offAll() {
          this.onlisteners = [];
      }
  }
  